<template>
    <div></div>
</template>
<script>
import axios from 'axios'
export default {
    name:'ItemsNC',
    props:['action','itemsEx'],
    data() {
        return {
            preitem: {},
            items:[]
        }
    },
    mounted() {
        this.initPreItem()
    },
    watch: {
        'action.i': function () {
                if(this.action.i){   
                    for( let i = 0; i<this.itemsEx.length; i++){ 
                        this.completeItem(i)
                    }
                }          
            },
        'action.reset': function () {
                if(this.action.reset){
                    this.items = []
                }   
            }    
    },
    methods: {
        initPreItem(){
            this.preitem = {
            unidadMedidaCantidad:"",
            cantidad: "",
            codigoProductoSunat: "",
            descripcion: "",
            valorUnitario: "",
            precioVentaUnitario: "",
            tipoPrecioVentaUnitario: "",
            montoTotalImpuestosItem: "",
            baseAfectacionIgv: "",
            montoAfectacionIgv: "",
            porcentajeImpuesto: "",
            tipoAfectacionIgv: "",
            codigoTributo: "",
            valorVenta: "",
            }   
        },
        completeItem(i){
            if(this.itemsEx){
                this.preitem.unidadMedidaCantidad = this.itemsEx[i].unidadMedidaCantidad
                this.preitem.cantidad = parseFloat(this.itemsEx[i].cantidad)
                this.preitem.codigoProductoSunat = this.itemsEx[i].codigoProductoSunat
                this.preitem.descripcion = this.itemsEx[i].descripcion
                this.preitem.valorUnitario = 0.00
                this.preitem.precioVentaUnitario = 0.00
                this.preitem.tipoPrecioVentaUnitario = this.itemsEx[i].tipoPrecioVentaUnitario
                this.preitem.montoTotalImpuestosItem = 0.00
                this.preitem.baseAfectacionIgv = 0.00
                this.preitem.montoAfectacionIgv = 0.00
                this.preitem.porcentajeImpuesto = 0.00
                this.preitem.tipoAfectacionIgv = this.itemsEx[i].tipoAfectacionIgv
                this.preitem.codigoTributo = this.itemsEx[i].codigoTributo
                this.preitem.valorVenta = 0.00
                this.preitem.codigoProducto = this.itemsEx[i].codigoProducto
                
                
                this.items.unshift(this.preitem)
                this.initPreItem()
                this.getItems(this.items)
            }
        },
        getItems(data){
            this.$emit("totalitems",data)
        }
    },
}
</script>